import { render, staticRenderFns } from "./folders-upload-buttons.vue?vue&type=template&id=299b6850&scoped=true"
import script from "./folders-upload-buttons.vue?vue&type=script&lang=js"
export * from "./folders-upload-buttons.vue?vue&type=script&lang=js"
import style0 from "./folders-upload-buttons.vue?vue&type=style&index=0&id=299b6850&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299b6850",
  null
  
)

export default component.exports